import { jsxs as g, jsx as s } from "react/jsx-runtime";
import { c as O, a as x } from "../../../vendor-B6xhktLJ.js";
import { forwardRef as I } from "react";
import { getSpacingClasses as p } from "../../../utils/getSpacingClasses/index.js";
import { omit as y } from "../../../utils/omit/index.js";
import { BaseIcon as C } from "../../BaseIcon/index.js";
import { isIconName as $ } from "../../BaseIcon/loadIcon/index.js";
import { TooltipTrigger as q, Tooltip as K } from "../../Tooltip/index.js";
import { s as a } from "../../../shared.module-DBUqf3DR.js";
import '../../../assets/index3.css';const N = "mqKZpW_iconButton", T = "mqKZpW_md", W = "mqKZpW_sm", d = {
  iconButton: N,
  md: T,
  sm: W
}, S = I(
  ({ size: r = "md", icon: e, variant: f = "primary", m: u, mt: i, mr: o, mb: b, ml: h, tooltip: n, ...m }, t) => {
    const B = O({
      [a.baseButton]: !0,
      [a[f]]: !0,
      [d.iconButton]: !0,
      [d[r]]: !0,
      ...p({ m: u, mt: i, mr: o, mb: b, ml: h })
    }), c = $(e);
    return c || console.warn(`${e} is not a valid icon name for IconButton.`), /* @__PURE__ */ g(
      q,
      {
        isDisabled: m.isDisabled || !(n != null && n.children),
        isOpen: n == null ? void 0 : n.isOpen,
        defaultOpen: n == null ? void 0 : n.defaultOpen,
        onOpenChange: n == null ? void 0 : n.onOpenChange,
        children: [
          /* @__PURE__ */ s(
            x,
            {
              ...y(m, ["className", "style", "isPending", "slot", "type"]),
              type: "button",
              className: B,
              ref: t,
              children: c && /* @__PURE__ */ s(C, { icon: e, size: r })
            }
          ),
          n && /* @__PURE__ */ s(K, { placement: n.placement, children: n.children })
        ]
      }
    );
  }
);
export {
  S as IconButton
};
//# sourceMappingURL=index.js.map
